import { Box, Card, Chip, Icon, IconButton, Tab, Tabs } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { useMaterialUIController } from "context";
import { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { get } from "utils/WebService";
import CadastroBasico from "./tabs/CadastroBasico";
import Contratos from "./tabs/Contratos";
import Historico from "./tabs/Historico";
import Acordos from "./tabs/Acordos";
import Juridico from "./tabs/Juridico";
import Honorarios from "./tabs/Honorarios";
import Documentos from "./tabs/Documentos";
import HeaderDevedor from "./tabs/HeaderDevedor";
import DadosCarteira from "./tabs/DadosCarteira";

export default function BaseDeDadosCreateEdit({ recordId, idDevedorCarteira, closeCreateEdit, isJuridico, isViewOnly, isFila = false }) {
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;
    const formRef = useRef();
    const [tabValue, setTabValue] = useState(1);
    const [visitedTabs, setVisitedTabs] = useState(new Set([1, 2, 3, 4, 5, 6, 7, 8, 9]));
    const [pendingContratos, setPendingContratos] = useState([]);
    const [refreshKey, setRefreshKey] = useState(0);
    const [loadingTabs, setLoadingTabs] = useState(true);
    const [selectedFichaFromHeader, setSelectedFichaFromHeader] = useState(null);

    const [currentRecordId, setCurrentRecordId] = useState(recordId);
    const [selectedFicha, setSelectedFicha] = useState(null);
    const [devedorData, setDevedorData] = useState(null);
    const [hasProcesso, setHasProcesso] = useState(false);
    const [hasHonorarios, setHasHonorarios] = useState(false);
    const [hasAcordos, setHasAcordos] = useState(false);
    const [hasAcordosHonorarios, setHasAcordosHonorarios] = useState(false);
    const [allContratos, setAllContratos] = useState([]);
    const [allAcordos, setAllAcordos] = useState([]);
    const [allHistoricos, setAllHistoricos] = useState([]);

    useEffect(() => {
        setCurrentRecordId(recordId);
        setSelectedFicha(null);
    }, [recordId]);

    useEffect(() => {
        if (idDevedorCarteira && devedorData?.fichas) {
            const match = devedorData.fichas.find(f => 
                String(f.id) === String(idDevedorCarteira) || 
                String(f.rawId) === String(idDevedorCarteira) ||
                String(f.idDevedorCarteira) === String(idDevedorCarteira)
            );
            if (match) {
                setSelectedFicha(match);
            }
        }
    }, [idDevedorCarteira, devedorData]);

    const handleChange = (event, newValue) => {
        let val = newValue !== undefined ? newValue : event;
        setTabValue(val);
        setVisitedTabs(prev => new Set(prev).add(val));
    };

    const checkTabVisibility = () => {
        if (!currentRecordId) return;

        get(`/devedor/by-id/${currentRecordId}`).then(res => {
            if (res) {
                setDevedorData(res);
                if (res.nome) {
                    sessionStorage.setItem('activeDevedorId', currentRecordId);
                    sessionStorage.setItem('activeDevedorNome', res.nome);
                    window.dispatchEvent(new Event('sessionStorageUpdate'));
                }
                if (res.fichas && Array.isArray(res.fichas) && res.fichas.length > 0) {
                    setSelectedFicha(prev => {
                        if (idDevedorCarteira) {
                            const match = res.fichas.find(f => 
                                String(f.id) === String(idDevedorCarteira) || 
                                String(f.rawId) === String(idDevedorCarteira) ||
                                String(f.idDevedorCarteira) === String(idDevedorCarteira)
                            );
                            if (match) return match;
                        }
                        if (prev) {
                            const updated = res.fichas.find(f => 
                                (prev.rawId && f.rawId && String(f.rawId) === String(prev.rawId)) ||
                                (prev.id && f.id && f.id === prev.id)
                            );
                            if (updated) return updated;
                        }
                        const firstActive = res.fichas.find(f => f.situacao !== 1);
                        return firstActive || res.fichas[0];
                    });
                }
            }
        }).catch(err => console.error(err));

        get(`/acordo/list/${currentRecordId}`).then(res => {
            if (res && Array.isArray(res)) {
                setAllAcordos(res);
                setHasAcordosHonorarios(res.some(a => a.isHonorario === true || a.honorario === true));
            }
        }).catch(err => console.error(err));

        get(`/contratos/list/${currentRecordId}`).then(res => {
            if (res && Array.isArray(res)) setAllContratos(res);
        }).catch(err => console.error(err));

        get(`/devedor/historico/${currentRecordId}`).then(res => {
            if (res && Array.isArray(res)) setAllHistoricos(res);
        }).catch(err => console.error(err));

        get(`/processos-transitorios/by-devedor/${currentRecordId}`).then(res => {
            if (res && Array.isArray(res) && res.length > 0) {
                setHasProcesso(true);
            } else {
                setHasProcesso(false);
            }
        }).catch(err => console.error(err));
    };

    useEffect(() => {
        checkTabVisibility();
        
        return () => {
            sessionStorage.removeItem('activeDevedorId');
            sessionStorage.removeItem('activeDevedorNome');
            window.dispatchEvent(new Event('sessionStorageUpdate'));
        };
    }, [currentRecordId]);

    const isFilho = Boolean(devedorData?.idDevedorPai || devedorData?.devedorPai);
    const isSelectedFichaHonorario = Boolean(
        selectedFicha?.isHonorario === true || 
        selectedFicha?.cbIsHonorario === true || 
        isFilho
    );

    useEffect(() => {
        if (isFilho && (tabValue === 6 || tabValue === 7)) {
            setTabValue(2);
        } else if (isSelectedFichaHonorario) {
            if (tabValue === 6) setTabValue(2);
            if (tabValue === 7) setTabValue(4);
        }
    }, [isFilho, isSelectedFichaHonorario, tabValue]);

    const showProcessos = hasProcesso || 
                          (Array.isArray(allContratos) && allContratos.some(c => c.idProcesso)) ||
                          (devedorData?.fichas && Array.isArray(devedorData.fichas) ? devedorData.fichas.some(f => f.isJuridico) : false);
    const showHonorarios = !isFilho && (
                           (devedorData?.fichas && Array.isArray(devedorData.fichas) ? devedorData.fichas.some(f => f.isHonorario) : false) || 
                           (Array.isArray(allContratos) ? allContratos.some(c => c.isHonorario === true || c.cbIsHonorario === true) : false) || 
                           (devedorData?.devedoresFilhos && devedorData.devedoresFilhos.length > 0) ||
                            hasAcordosHonorarios);

    const effectiveIdDevedorCarteira = selectedFicha?.id || selectedFicha?.idDevedorCarteira || (idDevedorCarteira ? String(idDevedorCarteira) : null);
    const effectiveRawIdDevedorCarteira = selectedFicha?.rawId != null ? String(selectedFicha.rawId) : null;

    return (
        <Card id="base-dados-info">
            <Box display="flex" alignItems="center" px={2} pt={2} pb={isViewOnly ? 1 : 2}>
                <IconButton onClick={closeCreateEdit} sx={{ p: 0, paddingRight: 2 }}>
                    <MDTypography variant="h5">
                        <Icon>arrow_back</Icon>
                    </MDTypography>
                </IconButton>
                {currentRecordId && (
                    <MDBox sx={{ flexGrow: 1 }}>
                        <HeaderDevedor 
                            recordId={currentRecordId} 
                            selectedFicha={selectedFicha}
                            onSelectFicha={(f) => setSelectedFicha(f)}
                            onNavigateToDevedor={setCurrentRecordId} 
                            onOpenDadosCarteira={(f) => {
                                setSelectedFicha(f);
                                setSelectedFichaFromHeader(f);
                                setTabValue(9);
                                setVisitedTabs(prev => new Set(prev).add(9));
                            }}
                        />
                    </MDBox>
                )}
            </Box>

            {/* Banner de Ficha Filha de Honorários de Terceiro */}
            {devedorData?.idDevedorPai && (
                <MDBox 
                    mx={2} 
                    mb={2} 
                    p={1.5} 
                    sx={{
                        borderRadius: "8px",
                        background: darkMode ? "#3e3725" : "#fff8e1",
                        border: `1px solid ${darkMode ? "#ffa000" : "#ffe082"}`,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        flexWrap: "wrap",
                        gap: 1
                    }}
                >
                    <MDBox display="flex" alignItems="center" gap={1.2}>
                        <Icon sx={{ color: "#ffa000", fontSize: "24px !important" }}>account_tree</Icon>
                        <MDBox>
                            <MDTypography variant="button" fontWeight="bold" sx={{ color: darkMode ? "#ffb74d" : "#e65100", display: "block" }}>
                                Ficha de Honorários de Terceiro (Embargos de Terceiro)
                            </MDTypography>
                            <MDTypography variant="caption" color="text">
                                Vinculada à Ficha Principal: <strong>{devedorData.nomeDevedorPai || "Devedor Principal"}</strong> {devedorData.documentoDevedorPai ? `(CPF/CNPJ: ${devedorData.documentoDevedorPai})` : ""}
                            </MDTypography>
                        </MDBox>
                    </MDBox>
                    <MDButton
                        variant="gradient"
                        color="warning"
                        size="small"
                        onClick={() => setCurrentRecordId(devedorData.idDevedorPai)}
                        sx={{ fontWeight: "bold" }}
                    >
                        <Icon sx={{ mr: 0.5 }}>arrow_upward</Icon> Ir para Ficha Principal
                    </MDButton>
                </MDBox>
            )}

            {/* Banner de Ficha Principal com Honorários de Terceiros Vinculados */}
            {devedorData?.devedoresFilhos && devedorData.devedoresFilhos.length > 0 && (
                <MDBox 
                    mx={2} 
                    mb={2} 
                    p={1.5} 
                    sx={{
                        borderRadius: "8px",
                        background: darkMode ? "#253444" : "#e3f2fd",
                        border: `1px solid ${darkMode ? "#1976d2" : "#90caf9"}`,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        flexWrap: "wrap",
                        gap: 1
                    }}
                >
                    <MDBox display="flex" alignItems="center" gap={1.2}>
                        <Icon sx={{ color: "#1976d2", fontSize: "24px !important" }}>folder_shared</Icon>
                        <MDBox>
                            <MDTypography variant="button" fontWeight="bold" sx={{ color: darkMode ? "#90caf9" : "#0d47a1", display: "block" }}>
                                Honorários de Terceiros Vinculados ({devedorData.devedoresFilhos.length})
                            </MDTypography>
                            <MDTypography variant="caption" color="text">
                                Existem fichas de Embargos de Terceiros vinculadas a este devedor principal.
                            </MDTypography>
                        </MDBox>
                    </MDBox>
                    <MDBox display="flex" gap={1} flexWrap="wrap">
                        {devedorData.devedoresFilhos.map((filho, idx) => (
                            <MDButton
                                key={filho.id || idx}
                                variant="gradient"
                                color="info"
                                size="small"
                                onClick={() => setCurrentRecordId(filho.id)}
                                sx={{ fontWeight: "bold" }}
                            >
                                <Icon sx={{ mr: 0.5 }}>open_in_new</Icon> {filho.nome || `Terceiro ${idx + 1}`}
                            </MDButton>
                        ))}
                    </MDBox>
                </MDBox>
            )}

            <MDBox sx={{ width: '100%', px: 2, mb: 8 }}>
                <MDBox sx={{ borderBottom: 1, width: "100%", borderColor: 'divider' }}>
                    <Tabs value={tabValue} onChange={handleChange} aria-label="base-dados-tabs">
                        <Tab label="Cadastro Básico" value={1} sx={{ fontSize: 12 }} />
                        {currentRecordId && <Tab label="Dados Carteira" value={9} sx={{ fontSize: 12 }} />}
                        <Tab label={isSelectedFichaHonorario ? "Honorários" : "Contratos"} value={2} sx={{ fontSize: 12 }} />
                        {currentRecordId && <Tab label="Histórico" value={3} sx={{ fontSize: 12 }} />}
                        <Tab label={isSelectedFichaHonorario ? "Acordos Honorários" : "Acordos"} value={4} sx={{ fontSize: 12 }} />
                        {currentRecordId && showProcessos && <Tab label="Processos" value={5} sx={{ fontSize: 12 }} />}
                        {currentRecordId && <Tab label="Documentos" value={8} sx={{ fontSize: 12 }} />}
                    </Tabs>
                </MDBox>

                <MDBox mt={3}>
                    <div role="tabpanel" hidden={tabValue !== 1} id={`tab-1`}>
                        <CadastroBasico formRef={formRef} recordId={currentRecordId} isJuridico={isJuridico} closeCreateEdit={closeCreateEdit} isViewOnly={isViewOnly} pendingContratos={pendingContratos} refreshKey={refreshKey} preloadedDevedor={devedorData} />
                    </div>
                    <div role="tabpanel" hidden={tabValue !== 9} id={`tab-9`}>
                        {visitedTabs.has(9) && <DadosCarteira recordId={currentRecordId} preloadedDevedor={devedorData} selectedFicha={selectedFicha} onSelectFicha={(f) => setSelectedFicha(f)} selectedFichaInitial={selectedFichaFromHeader} isViewOnly={isViewOnly} closeCreateEdit={closeCreateEdit} onDataUpdated={checkTabVisibility} />}
                    </div>
                    <div role="tabpanel" hidden={tabValue !== 2} id={`tab-2`}>
                        {visitedTabs.has(2) && <Contratos formRef={formRef} recordId={currentRecordId} idDevedorCarteira={effectiveIdDevedorCarteira} idDevedorCarteiraRaw={effectiveRawIdDevedorCarteira} selectedFicha={selectedFicha} isHonorariosTab={isSelectedFichaHonorario} isViewOnly={isViewOnly} isFila={isFila} pendingContratos={pendingContratos} setPendingContratos={setPendingContratos} changeTab={handleChange} onDataUpdated={checkTabVisibility} refreshKey={refreshKey} preloadedContratos={allContratos} preloadedAcordos={allAcordos} preloadedDevedor={devedorData} />}
                    </div>
                    <div role="tabpanel" hidden={tabValue !== 6} id={`tab-6`}>
                        {visitedTabs.has(6) && <Honorarios formRef={formRef} recordId={currentRecordId} isViewOnly={isViewOnly} pendingContratos={pendingContratos} setPendingContratos={setPendingContratos} changeTab={handleChange} onDataUpdated={checkTabVisibility} refreshKey={refreshKey} preloadedDevedor={devedorData} preloadedContratos={allContratos} preloadedAcordos={allAcordos} preloadedHistoricos={allHistoricos} onNavigateToDevedor={setCurrentRecordId} />}
                    </div>
                    <div role="tabpanel" hidden={tabValue !== 3} id={`tab-3`}>
                        {visitedTabs.has(3) && <Historico recordId={currentRecordId} idDevedorCarteira={effectiveIdDevedorCarteira} idDevedorCarteiraRaw={effectiveRawIdDevedorCarteira} selectedFicha={selectedFicha} isHonorariosTab={isSelectedFichaHonorario} isViewOnly={isViewOnly} refreshKey={refreshKey} preloadedDevedor={devedorData} preloadedHistoricos={allHistoricos} />}
                    </div>
                    <div role="tabpanel" hidden={tabValue !== 4} id={`tab-4`}>
                        {visitedTabs.has(4) && <Acordos recordId={currentRecordId} idDevedorCarteira={effectiveIdDevedorCarteira} idDevedorCarteiraRaw={effectiveRawIdDevedorCarteira} selectedFicha={selectedFicha} isViewOnly={isViewOnly} changeTab={handleChange} isHonorariosTab={isSelectedFichaHonorario} onDataUpdated={checkTabVisibility} refreshKey={refreshKey} preloadedAcordos={allAcordos} isFilho={isFilho} />}
                    </div>
                    <div role="tabpanel" hidden={tabValue !== 7} id={`tab-7`}>
                        {visitedTabs.has(7) && <Acordos recordId={currentRecordId} idDevedorCarteira={effectiveIdDevedorCarteira} idDevedorCarteiraRaw={effectiveRawIdDevedorCarteira} selectedFicha={selectedFicha} isViewOnly={isViewOnly} changeTab={handleChange} isHonorariosTab={true} onDataUpdated={checkTabVisibility} refreshKey={refreshKey} preloadedAcordos={allAcordos} />}
                    </div>
                    <div role="tabpanel" hidden={tabValue !== 5} id={`tab-5`}>
                        {visitedTabs.has(5) && <Juridico recordId={currentRecordId} isViewOnly={isViewOnly} refreshKey={refreshKey} preloadedDevedor={devedorData} />}
                    </div>
                    <div role="tabpanel" hidden={tabValue !== 8} id={`tab-8`}>
                        {visitedTabs.has(8) && <Documentos recordId={currentRecordId} isViewOnly={isViewOnly} />}
                    </div>
                </MDBox>
            </MDBox>
        </Card>
    );
}
